import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

const Tabs = ({ children }: any) => {
  const theme = useAtomValue(themeAtom);

  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const handleClick = (e: any, newActiveTab: any) => {
    e.preventDefault();
    setActiveTab(newActiveTab);
  };

  return (
    <>
      <div className={twMerge("flex gap-6 border-b-[1px]", theme.uwhcAssistant.border)}>
        {children.map((child: any) => (
          <button
            key={child.props.label}
            className={twMerge(
              theme.home.tailwind.textDefault,
              "flex-1 text-balance border-b-2 border-transparent px-2 pb-2 font-medium",
              activeTab === child.props.label && "border-green text-green",
            )}
            onClick={(e) => handleClick(e, child.props.label)}
          >
            {child.props.label}
          </button>
        ))}
      </div>
      <div className="py-4">
        {children.map((child: any) => {
          if (child.props.label === activeTab) {
            return <div key={child.props.label}>{child.props.children}</div>;
          }
          return null;
        })}
      </div>
    </>
  );
};

const Tab = ({ label: _label, children }: { label: string; children: React.ReactNode }) => {
  const theme = useAtomValue(themeAtom);
  return <div className={twMerge("hidden", theme.home.tailwind.textDefault)}>{children}</div>;
};
export { Tabs, Tab };
